const leafletMap = {

    init() {
        // MAP leaflet
        var lat = 48.809160;
        var lon = 2.362470;
        var lat2 = 49.504310;
        var lon2 = 6.009720;
        var macarte = null;
        var templateUrl = object_name.templateUrl;
        var contactMap = document.getElementById('map')
        function initMap() {
            var iconBase = templateUrl + '/assets/img/png/ico-location.png';

            // Set-up de l'icon 
            var myIcon = L.icon({
                iconUrl: iconBase ,
                iconSize: [50, 50],
                iconAnchor: [25, 50],
                popupAnchor: [-3, -76],
            });

            // Créer l'objet "macarte" et l'insèrer dans l'élément HTML qui a l'ID "map"
            macarte = L.map('map').setView([lat, lon], 10);

            // Nous ajoutons un marqueur
            var marker = L.marker([lat, lon], {icon: myIcon});
            var marker2 = L.marker([lat2, lon2], {icon: myIcon});

            // Ajout d'une pop-up
			marker.bindPopup('<div style="text-align:center;"><p><span>Systemis</span> Paris</p><p style="margin:5px 0;">108 Avenue de Fontainebleau<br>94270 Le Kremblin-Bicêtre,</p><p style="margin:5px 0;">FRANCE</p><p style="margin:5px 0;"><a href="tel:+33820222302">(0) 820 222 302</a></p></div>');
			marker2.bindPopup('<div style="text-align:center;"><p><span>Systemis</span> Luxembourg</p><p style="margin:5px 0;">12 rue de la paix<br>L-3871 Schifflange,</p><p style="margin:5px 0;">LUXEMBOURG</p></div>');
		

            var markers = [
                marker,
                marker2
            ]

            var group = L.featureGroup(markers).addTo(macarte);

            macarte.fitBounds(group.getBounds());
            // macarte.setView([lat, lon]);

            // Leaflet ne récupère pas les cartes (tiles) sur un serveur par défaut. Nous devons lui préciser où nous souhaitons les récupérer. Ici, openstreetmap.fr
            L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                // Il est toujours bien de laisser le lien vers la source des données
                attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
                minZoom: 1,
                maxZoom: 20
            }).addTo(macarte);

        }
        if(contactMap) {
            initMap();
        }
    }
}

export default leafletMap;